import React from 'react';
import PropTypes from 'prop-types';
import { message } from 'antd';
import s from './NewGroup.css';
import Breadcrumbs from '../../components/Breadcrumbs';
import { Link } from 'react-router-dom';
import history from '../../history';
import iconv from 'iconv-lite';

class RenameGroup extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
    id: PropTypes.string.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      config: require('Config'),
    };
    this.textChange = this.textChange.bind(this);
  }

  componentDidMount() {
    fetch(this.state.config.serverUrl + `groups/${this.props.id}`,
        {
            headers: new Headers({
                'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                'username': `${sessionStorage.getItem('username')}`
            })
        })
      .then(response => response.json())
      .then(response => this.setState({ name: response.name }));
  }

  textChange(event) {
      event.target.value = event.target.value.replace(',', '');
      this.setState({ name: event.target.value});
  }

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  renameGroup = (e) => {
    e.preventDefault();
    fetch(this.state.config.serverUrl + `groups/${this.props.id}`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'PUT',
        body: JSON.stringify({ name: this.state.name }),
      },
    )
      .then((response) => {
        if (response.status === 204) {
          this.successMessage();
          history.push('/groups/' + this.props.id);
        } else {
          this.errorMessage(response.statusText);
        }
      });
  };

  render() {
    return (
      <div className={s.root}>
        <Breadcrumbs title={this.props.locale.breadcrumbs} link={'/groups/' + this.props.id} />
        <h1>{this.props.locale.title}</h1>
        <form onSubmit={this.renameGroup}>
          <label className={s.input_wrapper} htmlFor="input">
            <span className={s.input_name}>{this.props.locale.nameLabel}</span>
            <input
              className={s.text_input}
              name="input"
              placeholder={this.props.locale.namePlaceholder}
              value={this.state.name}
              onChange={this.textChange}
            />
          </label>
          <div className={s.button_wrapper}>
            <Link className={s.btn_warning} to={'/groups/' + this.props.id}>{this.props.locale.buttonCancel}</Link>
            <button className={s.btn_primary}>{this.props.locale.buttonRename}</button>
          </div>
        </form>
      </div>
    );
  }
}

export default (RenameGroup);




// WEBPACK FOOTER //
// ./src/routes/groups/RenameGroup.js